import { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { prop } from 'ramda';

import { CategoryContext } from '@core/js/components/main/Games/context';
import { useDeviceSelector, useUserSelector } from '@core/js/store/hooks';

export const useGameAttributes = ({ name, position }) => {
    const isMobile = useDeviceSelector(prop('isMobile'));
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const { name: categoryName } = useContext(CategoryContext);
    const { pathname } = useLocation();
    const pageName = pathname.slice(1);
    const categoryNameParsed = categoryName?.toLowerCase().replace(/[^\w_]+/g, '-') || '';

    if (!isMobile || !isLoggedIn) {
        return {};
    }

    return {
        'data-game-name': name,
        [`data-${pageName || 'home'}-${categoryNameParsed}`]: position
    };
};
